<mat-progress-bar [color]="color"
                  [value]="strength"
                  mode="determinate">
</mat-progress-bar>
